function base64UrlEncode(bytes) {
	let binary = ''
	bytes.forEach((byte) => {
		binary += String.fromCharCode(byte)
	})
	return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export function generateCodeVerifier() {
	const bytes = new Uint8Array(32)
	crypto.getRandomValues(bytes)
	return base64UrlEncode(bytes)
}

export async function generateCodeChallenge(verifier) {
	const data = new TextEncoder().encode(verifier)
	const digest = await crypto.subtle.digest('SHA-256', data)
	return base64UrlEncode(new Uint8Array(digest))
}

export function generateState() {
	const bytes = new Uint8Array(16)
	crypto.getRandomValues(bytes)
	return base64UrlEncode(bytes)
}
